import tw from 'tailwind-styled-components';

const Overlay = tw.div`
    fixed top-0 left-0 bottom-0 right-0
    flex flex-col items-center justify-center
    bg-white
    p-12
    z-50
`;

export default Overlay